import React from "react";
import ReportPage from "./ReportPage";

export default function NHFReports() {
  return (
    <ReportPage
      title="NHF Reports"
      subtitle="National Housing Fund schedule."
      endpoint="/reports/statutory/nhf"
      exportName="nhf"
      summaryCards={[
        { key: "total_amount", label: "Total Amount", money: true },
        { key: "staff_count_on_page", label: "Staff Count" },
      ]}
      columns={[
        { key: "pf_no", label: "PF No" },
        { key: "fullname", label: "Name" },
        { key: "item", label: "Item" },
        { key: "amount", label: "Amount" },
      ]}
    />
  );
}
